import React from "react";
import { connect } from "react-redux";
import AvailabilityDonut from "../AvailabilityDonut";
import { sendPostRequest } from "../../../../../actions/app-actions";
import { getAdminBusinessId } from "../../../../../utils/authHelper";

const StaffPieChart = (props) => (
  <AvailabilityDonut
    sendPostRequest={props.sendPostRequest}
    url={`/admin/staff-availability-ratio-chart/${getAdminBusinessId()}`}
    title="Team utilization"
    subtitle="Booked hours vs. available hours per staff member"
    tooltipCode="P3F7"
    filterKey="staff_id"
    filterOptions={props.staffs}
    filterPlaceholder="All staff"
  />
);

export default connect(null, { sendPostRequest })(StaffPieChart);
